import { c as _c } from "react/compiler-runtime";
import BnefLogo from '@/components/Atoms/BnefLogo/BnefLogo';
import { Icon, IconSize } from '@/components/Atoms/Icon/Icon';
import ArrowRight from '@/components/Icons/ArrowRight';
import { Stack } from '@/components/Molecules/Stack/Stack';
import { SubmittingAnimation } from '@/components/Pages/Login/SubmittingAnimation';
import styles from '@/components/Pages/TransparentRedirectViews/TransparentRedirectView.module.css';
import { useEffect, useState } from 'react';
interface ILoginTokenPostPage {
  postUrl: string;
  token: string;
  redirectUrl: string;
}

// When users return from SSO flow or NEFW with 1-time use token in GET query string
// we have seen a few cases where security scanner GET the URL and use the token before the browser does
// or Android Chrome use the token before redirecting to Home screen App
// This page renders on GET requests that and just re-submit the token via POST form to avoid the code being used early
export const LoginTokenPostPage = t0 => {
  const $ = _c(22);
  const {
    postUrl,
    token,
    redirectUrl
  } = t0;
  const [submitting, setSubmitting] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      document.forms[0].submit();
      setSubmitting(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.logoSpace} title="BloombergNEF"><BnefLogo /></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== token) {
    t4 = <input type="hidden" name="token" value={token} />;
    $[3] = token;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== redirectUrl) {
    t5 = <input type="hidden" name="r" value={redirectUrl} />;
    $[5] = redirectUrl;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== submitting) {
    t6 = submitting && {
      display: "none"
    };
    $[7] = submitting;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon use={<ArrowRight />} size={IconSize.TEXT} />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <button type="submit" css={t6}>Login {t7}</button>;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== postUrl || $[13] !== t4 || $[14] !== t5 || $[15] !== t8) {
    t9 = <form method="post" action={postUrl}>{t4}{t5}{t8}</form>;
    $[12] = postUrl;
    $[13] = t4;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== submitting) {
    t10 = submitting && <SubmittingAnimation />;
    $[17] = submitting;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className={styles.container}><Stack>{t3}{t9}{t10}</Stack></div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};